// ----
// OUP-specific IQVIA event handler
// Subscribes to platform IQVIA events and implements OUP-specific targeting logic
// ----

var App = App || {};

App.IqviaHandler = (function() {
    
    return {
        init: init
    };
    
    function init() {
        if (typeof SCM === 'undefined' || !SCM.EventEmitter) {
            return;
        }
        
        subscribeToIqviaEvents();
    }
    
    function subscribeToIqviaEvents() {
        SCM.EventEmitter.subscribe(Theme.Iqvia.Events.IDENTITY_RESOLVED, function(data) {
            handleIdentityResolved(data);
        });
        
        SCM.EventEmitter.subscribe(Theme.Iqvia.Events.ERROR, function(data) {
            console.log('OUP: IQVIA error occurred', data.error);
        });
    }
    
    function handleIdentityResolved(data) {
        if (data.value && typeof googletag !== 'undefined') {
            googletag.cmd.push(function () {
                googletag.pubads().setTargeting('IQVIA', [data.value]);
            });
        }
    }
})();